module.exports = __webpack_public_path__ + "img/hot-plan.7dc0a608.svg";